import '@rc-component/color-picker/assets/index.css';

import { Color }              from '@rc-component/color-picker';
import type { FormInstance }  from 'antd';
import React                  from 'react';
import { observer }           from 'mobx-react';
import { Col }                from 'antd';
import Row                    from 'components/App/Row';
import { Form }               from 'antd';
import Input                  from 'components/App/IntlInput';
import LayoutTypeModel        from 'models/LayoutTypeModel';
import handleFormError        from 'utils/handleFormError';
import FormItem               from 'components/App/FormItem';
import ColorPicker            from '@rc-component/color-picker';
import { AppFormComponent }   from 'components/App/AppForm';
import { messageSuccessIntl } from 'utils/messageIntl';

interface LayoutTypeFormProps {
  model: LayoutTypeModel;
  onSuccess: (model: LayoutTypeModel) => void;
}

@observer
class LayoutTypeForm extends AppFormComponent<LayoutTypeFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public componentDidMount() {
    this.setInitialValues();
  };

  public componentDidUpdate(prevProps: LayoutTypeFormProps) {
    if (prevProps.model.id !== this.props.model.id) {
      this.setInitialValues();
    }
  };

  public render(){
    return (
      <Form className="antd-form-custom-style" ref={this.formRef}>
        <Row>
          <Col md={12} sm={24}>
            <FormItem label="Label" name="label">
              <Input placeholder="label" />
            </FormItem>
          </Col>
          <Col md={12} sm={24}>
            <FormItem label="Couleur" name="color">
              <ColorPicker />
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  };

  public setInitialValues = async () => {

    const { model } = this.props;

    this.formRef.current?.setFieldsValue({
      color: new Color(model.color),
      label: model.label,
    });
  };

  public submit = async () => {
    const { model, onSuccess } = this.props;

    const values = await this.formRef.current?.validateFields();

    try {
      await model.patch({
        ...values,
        color: values.color.toHexString(),
      });

      messageSuccessIntl("Enregistrement réussi !");

      if (onSuccess) {
        onSuccess(model);
      }

      this.formRef.current?.resetFields();
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };
}

export default LayoutTypeForm;
